module.exports = __webpack_public_path__ + "img/zaun.9b79d617.webp";